import { useContext } from "react";
import { useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { OpacityContext } from './opacity';
//delay atrelado com fadeDuration em Body, use o mesmo valor para ambos os componentes para ter uma UX consistente
export default function DelayedLinkWithFadeout ({ delay=process.env.REACT_APP_DEFAULT_FADE_TIME, replace, state, to, setOpacity, ...props }) {
    const navigate = useNavigate();
    const timerRef = useRef();
    const { visibility } = useContext(OpacityContext);
    useEffect(() => () => clearTimeout(timerRef.current), []);
  
    const clickHandler = (e) => {
      e.preventDefault();
      visibility.set('opacity-0')
      timerRef.current = setTimeout(() => {
        visibility.set('')
        navigate(to, {replace, state})
      }, delay);
    };
  
    return <Link to={to} {...props} className={`transition-all duration-500 ${visibility.get} ${props.className}`} onClick={clickHandler}>{props.children} </Link>;
  };